// extracted by css-extract-rspack-plugin
export default {"MetadataSidebarContainer":"MetadataSidebar-module__MetadataSidebarContainer__tk5O7","CreateIssueAssigneesSection":"MetadataSidebar-module__CreateIssueAssigneesSection__gNzDQ"};